import { SnapshotService } from './../snapshot/snapshot.service';
import { Injectable } from '@angular/core';
import { LocalDBService } from '../service/local-db.service';

const CLIENT_ALIAS_LOCAL_DB_KEY = 'ClientAliases'

@Injectable({
    providedIn: 'root'
})
export class AliasService {
    clientAliases: { [key: string]: string } = {};

    constructor(private localDBService: LocalDBService,
        private snapshotService: SnapshotService) {
        this.reinitializeAliasesFromLocalDB();
    }

    reinitializeAliasesFromLocalDB() {
        const localDBAccountAliases = this.localDBService.getItem(CLIENT_ALIAS_LOCAL_DB_KEY);
        if (localDBAccountAliases) {
            this.clientAliases = JSON.parse(localDBAccountAliases);
        }
    }

    accountShortName(accountName: string): string {
        return this.snapshotService.applicationConfiguration.accountNames[accountName];
    }

    updateClientAliases(aliases: { id: string, alias: string }[]) {
        this.clientAliases = aliases
            .reduce((mapping, alias) => {
                mapping[alias.id] = alias.alias;
                return mapping;
            }, {});
        this.localDBService.setItem(CLIENT_ALIAS_LOCAL_DB_KEY, JSON.stringify(this.clientAliases));
    }

    clientAlias(clientIdentifier: string): string {
        const alias = this.clientAliases[clientIdentifier];
        if (alias) {
            return alias;
        } else {
            return clientIdentifier;
        }
    }
}
